// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"kk","header":"kl","title":"km","subheader":"kn","formWrapper":"ko"};